export const Badge = {
  delimiters: ["#{", "}"],
  props: ["text"],
  template: `<div class='badge text-sm-500'>
      #{text} 
  </div>`,
};
